import React, { useEffect, useState } from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton, BaseSelectComponent } from '../../../shared';
import { useFormik } from "formik";
import * as Yup from "yup";
import Switch from "react-switch";
import { Offsymbol, OnSymbol } from '../../../constants/holcim';

export const NormRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, labTypes, typesRegulation, modalClose }) => {

    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
    }, [showModal])

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: isUpdate ? rowInfo.name : '',
            description: isUpdate ? rowInfo.description : '',
            laboratoryType: isUpdate ? rowInfo.laboratoryType?.id : null,
            typesRegulation: isUpdate ? rowInfo.typesRegulation?.id : null,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Ingrese la norma"),
            description: Yup.string().required("Ingrese la descripción de la norma"),
            laboratoryType: Yup.string().required("Seleccione el tipo de laboratorio"),
            typesRegulation: Yup.string().required("Seleccione el tipo de normativa"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values, active);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(false);
    };

    const children_form = (
        <div>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Norma</h4>
            <GradientDecorationLine />
            <Form onSubmit={formikFormData.handleSubmit}>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Tipo de laboratorio</label>
                    <BaseSelectComponent
                        disabled={isUpdate}
                        options={labTypes.map((lt) => ({ value: lt.id, label: lt.name }))}
                        value={formikFormData.values.laboratoryType}
                        onChange={(value) => formikFormData.setFieldValue("laboratoryType", value)}
                        placeholder="Seleccione el tipo de laboratorio"
                        error="Seleccione el tipo de laboratorio"
                        touched={formikFormData.touched.laboratoryType && formikFormData.errors.laboratoryType}
                        status={formikFormData.touched.laboratoryType && formikFormData.errors.laboratoryType ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Tipo de normativa</label>
                    <BaseSelectComponent
                        options={typesRegulation.map((tr) => ({ value: tr.id, label: tr.name }))}
                        value={formikFormData.values.typesRegulation}
                        onChange={(value) => formikFormData.setFieldValue("typesRegulation", value)}
                        placeholder="Seleccione el tipo de normativa"
                        error="Seleccione el tipo de normativa"
                        touched={formikFormData.touched.typesRegulation && formikFormData.errors.typesRegulation}
                        status={formikFormData.touched.typesRegulation && formikFormData.errors.typesRegulation ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Norma</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Norma"
                        type="text"
                        {...formikFormData.getFieldProps('name')}
                        invalid={formikFormData.touched.name && !!formikFormData.errors.name}
                    />
                    {formikFormData.touched.name && formikFormData.errors.name && <FormFeedback>{formikFormData.errors.name}</FormFeedback>}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Descripción de norma</label>
                    <Input
                        name="description"
                        className="form-control text-primary"
                        placeholder="Descripción de norma"
                        type="textarea"
                        rows="3"
                        {...formikFormData.getFieldProps('description')}
                    />
                </div>
                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => { setActive(!active) }}
                        checked={active}
                    />
                </div>
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-4'
                            onClick={formikFormData.handleSubmit}
                            label="Guardar"
                            icon="mdi mdi-content-save me-1"
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={() => { onClosed() }}
                            label="Cancelar"
                            icon="mdi mdi-close-circle-outline me-1"
                        />
                    </div>
                </div>
            </Form>
        </div>
    );

    return (
        <BaseCustomModal
            isModalOpen={showModal}
            handleCancel={onClosed}
            footer={null}
            children={children_form}
            width={700}
        />
    );
};